import React, { ReactNode } from "react";

type customDropdownMenuProps = {
  style?: React.CSSProperties;
  customStyle?: React.CSSProperties;
  children: ReactNode;
  className?: string;
};

const CustomDropdownMenu = React.forwardRef<
  HTMLDivElement,
  customDropdownMenuProps
>(({ style, customStyle, children, className }, ref) => (
  <div ref={ref} className={className} style={{ ...style, ...customStyle }}>
    {children}
  </div>
));

export default CustomDropdownMenu;
